// extracted by mini-css-extract-plugin
export default {"floatingButton":"MembershipCardFloatingButton_floatingButton__2dtZe"};